import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
export const dynamicHead = {
    data() {
        return {
            defaultImage: "https://api.tochkabud.com.ua/images/ogimage.png",
            params: {},
        };
    },
    head: function() {
        const seo = this.params;
        return {
            title: () => {
                return {
                    inner: seo?.meta_title ? seo.meta_title : "Точка | магазин будівельних матеріалів",
                    separator: " ",
                    complement: "",
                };
            },
            link: function() {
                const original = window.location.origin;
                const basePath = window.location.pathname;

                return [
                    {
                        rel: "canonical",
                        href: original + basePath,
                        id: "canonical",
                    },

                    {
                        rel: "alternate",
                        hreflang: "uk-UA",
                        href: original + basePath.replace("/ru", ""),
                        id: "ua",
                    },
                    {
                        rel: "alternate",
                        hreflang: "ru-UA",
                        href: original + "/ru" + basePath.replace("/ru", ""),
                        id: "ru",
                    },
                ];
            },
            meta: () => {
                let ogType = "website";

                switch (this.$route.name) {
                    case "article":
                        ogType = "news";
                        break;
                    case "manuals":
                    case "manuals-category":
                    case "manual":
                        ogType = "article";
                        break;
                }
                const ogLocale = this.$route.params.lang === "uk" ? "uk_UA" : "ru_RU";
                let meta = [
                    { n: "keywords", content: seo?.meta_keywords || seo?.keywords || seo?.title, id: "keywords" },
                    { n: "title", content: seo?.meta_title || seo?.title, id: "title" },
                    { n: "description", content: seo?.meta_description || seo?.description, id: "description" },

                    { p: "og:title", content: seo?.meta_title || seo?.title, id: "og_title" },
                    { p: "og:description", content: seo?.meta_description || seo?.description, id: "og_description" },
                    { p: "og:image", content: seo?.image || this.params.image || this.defaultImage, id: "og_image" },
                    { p: "og:site_name", content: "tochkabud", id: "og_site_name" },
                    { p: "og:url", content: window.location, id: "og_url" },
                    { p: "og:type", content: ogType, id: "og_website" },
                    { p: "og:locale", content: ogLocale, id: "og_locale" },

                    { p: "twitter:title", content: seo?.meta_title || seo?.title, id: "twitter_title" },
                    {
                        p: "twitter:description",
                        content: seo?.meta_description || seo?.description,
                        id: "twitter_description",
                    },
                    {
                        p: "twitter:image",
                        content: seo?.image || this.params.image || this.defaultImage,
                        id: "twitter_image",
                    },
                ];
                if (!!Object.keys(this.$route.query)?.length || this.$route.params.filterSlug?.length) {
                    if (!meta.some(metaData => metaData.n === "robots")) {
                        if (!document.querySelectorAll("meta[name=robots]").length) {
                            meta.push({ n: "robots", c: "noindex, nofollow" });
                        }
                    }
                } else {
                    document.querySelectorAll("meta[name=robots]").forEach(item => item.remove());
                    meta = meta.filter(item => item.n !== "robots");
                }

                return meta;
            },
        };
    },
    watch: {
        $route() {
            this.setMeta();
        },
        product: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setMeta();
                }
            },
        },
    },
    methods: {
        setPageItem(item) {
            this.params = item;
            console.log("SEO: ", item);
            this.$emit("updateHead");
        },
        setMeta() {
            this.$emit("updateHead");
        },
    },
};
